<template>
  <div>
    <template v-for="(tariff, i) in tariffs">
      <pricing-tariffs-features-slider
        v-if="current === i"
        :key="`slider-${i}`"
        :tariff="tariff"
      ></pricing-tariffs-features-slider>
    </template>
  </div>
</template>

<script>
import PricingTariffsFeaturesSlider from './PricingTariffsFeaturesSlider.vue';
import translations from './pricing-translations';

export default {
  name: 'PricingTariffsFeaturesSliders',
  components: { PricingTariffsFeaturesSlider },
  props: {
    current: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    region() {
      return window.region;
    },
    lang() {
      return this.region === 'ai' ? 'en' : 'ru';
    },
    tariffs() {
      return Object.keys(translations[this.lang].tariffs);
    },
  },
  beforeDestroy() {
    this.$emit('handleTab', this.current);
  },
};
</script>
